__turbopack_context__.v({
  "button": "Newsletter-module__mgCv5W__button",
  "cgu": "Newsletter-module__mgCv5W__cgu",
  "checkboxWrapper": "Newsletter-module__mgCv5W__checkboxWrapper",
  "dataPolicy": "Newsletter-module__mgCv5W__dataPolicy",
  "form": "Newsletter-module__mgCv5W__form",
  "input": "Newsletter-module__mgCv5W__input",
  "inputButtonWrapper": "Newsletter-module__mgCv5W__inputButtonWrapper",
  "inscriptionDoneTitle": "Newsletter-module__mgCv5W__inscriptionDoneTitle",
  "subTitle": "Newsletter-module__mgCv5W__subTitle",
  "themeGreen": "Newsletter-module__mgCv5W__themeGreen",
  "title": "Newsletter-module__mgCv5W__title",
});
